import { useState } from 'react'
import { ChartMode, ChartView, ConversionWindow } from '@/hooks/useChartData'

export function useAnalyticsChartsState() {
  const [chartMode, setChartMode] = useState<ChartMode>('volume')
  const [conversionWindow, setConversionWindow] = useState<ConversionWindow>(7)
  const [chartView, setChartView] = useState<ChartView>('daily')
  const [visibleLines, setVisibleLines] = useState<Record<string, boolean>>({
    leads: true,
    appointments: true,
    visitors: true,
    sales: true,
    cr1: true,
    cr2: true,
    cr3: true,
    crTotal: true,
    revenue: true,
    newRevenue: true,
    existingRevenue: true
  })

  return {
    chartMode,
    setChartMode,
    conversionWindow,
    setConversionWindow,
    chartView,
    setChartView,
    visibleLines,
    setVisibleLines
  }
}
